// extracted by mini-css-extract-plugin
export default {"truncatingPill":"TruncatingPill_truncatingPill__pKzEq","text":"TruncatingPill_text__FGEYm","tooltipAnchor":"TruncatingPill_tooltipAnchor__E7SQK"};